import { FC, useContext } from 'react'
import { UploadSelectButton } from './UploadSelectButton'
import { Modal } from '../components/modal/Modal'
import './UploadForm.scss'
import { UploadFormUrl } from './UploadFormUrl'
import { UploadFormDrop } from './UploadFormDrop'
import { AppContext } from '../AppContext'
import { useSuppressCutterHotkeys } from '../hooks/useSuppressCutterHotkeys'

export const UploadForm: FC = () => {
  const { setUploadOpened } = useContext(AppContext)
  const close = () => setUploadOpened(false)

  useSuppressCutterHotkeys()

  return (
    <Modal className="UploadForm" header="Select audio file" close={close}>
      <UploadFormDrop
        caption={
          <>
            Drag & drop or <UploadSelectButton />
          </>
        }
      />

      <div className="or">Or</div>

      <UploadFormUrl />
    </Modal>
  )
}
